/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/ActionsAction/Content/Content/DeleteAction/Confirmation/Content/DeleteAction",
  onSubmit,
  isSubmitting
  
}) {
let deleteChargeSubmitData = fromData.useDataSubmit({ viewPath,
context: 'delete_charge',
})
let deleteChargeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'delete_charge',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="delete_charge"
 onClick={deleteChargeSubmitData}
 disabled={deleteChargeIsSubmittingData}
 text="Delete"
/>
{children}
</React.Fragment>)
}